// GoPhish stores pages and emails separately. Persist the explicit association
// in the email document's head, which survives GoPhish reads and HTML editing.
// The email ID is the simulation template ID; names are never used as a key.
const marker = /<meta\s+name=["']emailveritas-simulation-template["']\s+content=["']v1:(\d+)["']\s*\/?\s*>/i;
const detailsMarker = /<meta\s+name=["']emailveritas-simulation-details["']\s+content="([^"]*)"\s*\/?\s*>/i;

export function simulationDetails(html = '') {
  try {
    const match = html.match(detailsMarker);
    if (!match) return {};
    const data = JSON.parse(decodeURIComponent(match[1]));
    return { description: typeof data.description === 'string' ? data.description : '',
      category: typeof data.category === 'string' ? data.category : '', source: data.source };
  } catch { return {}; }
}

export function simulationPageId(html = '') {
  const match = html.match(marker);
  return match ? Number(match[1]) : null;
}

export function associateSimulationPage(html = '', pageId, details = {}) {
  if (!Number.isSafeInteger(Number(pageId)) || Number(pageId) <= 0) throw new Error('Invalid landing page ID');
  const tag = `<meta name="emailveritas-simulation-template" content="v1:${Number(pageId)}"><meta name="emailveritas-simulation-details" content="${encodeURIComponent(JSON.stringify({
    description: details.description || '', category: details.category || '', source: details.source
  }))}">`;
  const clean = html.replace(marker, '').replace(detailsMarker, '');
  if (/<head\b[^>]*>/i.test(clean)) return clean.replace(/<head\b[^>]*>/i, head => head + tag);
  if (/<html\b[^>]*>/i.test(clean)) return clean.replace(/<html\b[^>]*>/i, root => `${root}<head>${tag}</head>`);
  return `<!DOCTYPE html><html><head>${tag}</head><body>${clean}</body></html>`;
}

export function simulationTemplates(pages, messages) {
  const byId = new Map(pages.map(page => [Number(page.id), page]));
  return messages.filter(message => simulationPageId(message.html)).map(message => ({
    ...simulationDetails(message.html),
    id: message.id, name: message.name, message, page: byId.get(simulationPageId(message.html)) || null,
    icon: 'mail-open-file', existing: true
  }));
}
